import { useRef, useEffect, useState } from "react";

export const SignaturePad = ({ onChange }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    ctx.lineWidth = 2.5; ctx.lineCap = "round"; ctx.strokeStyle = "#0a0a0a";
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return [(p.clientX - r.left) * (ref.current.width / r.width), (p.clientY - r.top) * (ref.current.height / r.height)];
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; ref.current.toBlob((b) => onChange(b), "image/png"); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange(null); };

  return (
    <div data-testid="signature-pad">
      <canvas ref={ref} width={600} height={220}
        className="w-full h-28 border border-dashed border-gray-300 bg-white touch-none cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        data-testid="signature-canvas" />
      <div className="flex items-center justify-between mt-1">
        <span className="font-mono text-[10px] tracking-[0.14em] uppercase text-gray-400">{empty ? "Recipient signs here" : "Signed"}</span>
        <button type="button" onClick={clear} className="font-mono text-[10px] tracking-[0.14em] uppercase text-gray-500 hover:text-[#0a0a0a]" data-testid="signature-clear-button">Clear</button>
      </div>
    </div>
  );
};
